import { render } from "./CRMWhatsappInvoicesDialog.vue?vue&type=template&id=7f4da8c2&scoped=true"
import script from "./CRMWhatsappInvoicesDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappInvoicesDialog.vue?vue&type=script&lang=js"

import "./CRMWhatsappInvoicesDialog.vue?vue&type=style&index=0&id=7f4da8c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4da8c2"]])

export default __exports__